import { render, staticRenderFns } from "./preview-modal.vue?vue&type=template&id=2f6f9e23&"
import script from "./preview-modal.vue?vue&type=script&lang=js&"
export * from "./preview-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports